
import { Box, Grid, InputAdornment, TableSortLabel } from '@mui/material'
import _ from 'lodash'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { UseSnCode } from 'utils/useSnCode'

//component
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'

//utils
import { numberFormat } from 'utils/app.utils'

/** STYLE */
import * as UseStyled from 'features/report/useStyled'

//API
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import TreatmentRightApi from 'api/setting/treatment-right.api'
import Loading from 'component/Loading'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import { ExportProps } from '../report-constants'
import TreatmentRightBalanceList from './treatmentRightBalanceList'


export default function TreatmentRightBalance() {
    const { t } = useTranslation()
    const history = useHistory();
    const componentRef = useRef<HTMLDivElement>(null)
    const [branches, setBranches] = useState<any[]>([])
    const [treatmentRight, setTreatmentRight] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true);

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(10)
    const [search, setSearch] = useState<string>('')

    const [branchId, setBranchId] = useState<any>(0)
    const [treatmentRightId, setTreatmentRightId] = useState<any>(0)

    const [data, setData] = useState<any>([]);
    const [dataExport, setDataExport] = useState<any>([]);
    const [fetch, setFetch] = useState<boolean>(false)

    const [rowCount, setRowCount] = useState<number>(0);

    const [snType, setSnType] = useState(false);

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode();
            setSnType(sn);
        };

        fetchData();

    }, [snType]);

    useEffect(() => {
        handleSnCode()
    }, [])

    const { onDownload } = useDownloadExcel({
        tableExportRef: componentRef.current,
        filename: `${t(`REPORT.REPORT_NAME.TREATMENT_RIGHT_BALANCE`)}`,
        sheetName: `${t(`REPORT.REPORT_NAME.TREATMENT_RIGHT_BALANCE`)}`
    })

    const getAllFilter = () => {
        return [
            {
                label: t('INPUT.SEARCH'),
                value: search
            }, {
                label: t('REPORT.FILTER.BRANCH'),
                value: _.get(_.find(branches, { branchId }), 'branchName') || _.get(_.find(branches, { branchId }), 'branchNameEn') || t('REPORT.REPORT_GROUP.ALL')
            },
            {
                label: t('REPORT.FILTER.TREATMENT'),
                value: treatmentRightId ? treatmentRightId.treatmentRightName : t('REPORT.REPORT_GROUP.ALL')
            }]
    }

    const loadDataExport = useCallback(async () => {
        setLoading(true)
        let condition: any = {
            page: page,
            pageLimit: limit,
            export: 1
        }

        if (branchId && branchId !== 0) {
            condition = { ...condition, branchId }
        }
        if (treatmentRightId) {
            if (treatmentRightId.treatmentRightId !== 0) condition = { ...condition, treatmentRightId: treatmentRightId.treatmentRightId }

        }
        if (!_.isEmpty(search)) {
            condition.search = search
        }

        ReportApi.reportTreatmentRightBalance(condition)
            .then(({ headers, data }) => {
                setDataExport(data)
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
                setFetch(false)
            })

    }, [page, limit, fetch,])


    const fetchTreatmentRightBalance = useCallback(() => {
        setLoading(true)
        let condition: any = {
            page: page, pageLimit: limit
        }

        if (branchId && branchId !== 0) {
            condition = { ...condition, branchId }
        }
        if (treatmentRightId) {
            if (treatmentRightId.treatmentRightId !== 0) condition = { ...condition, treatmentRightId: treatmentRightId.treatmentRightId }

        }
        if (!_.isEmpty(search)) {
            condition.search = search
        }

        ReportApi.reportTreatmentRightBalance(condition)
            .then(({ headers, data }) => {
                setData(data)
                setRowCount(headers['x-total'])
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
                setFetch(false)
            })

    }, [page, limit, fetch])

    const verifyPermission = async () => {
        const condition: FindAllReportInterface = {
            page: 1, pageLimit: 200
        }
        ReportApi.reportList(condition)
            .then(({ data }) => {
                const check = _.find(data, (val: any) => String(val.reportKey) === 'TREATMENT_RIGHT_BALANCE') ? true : false
                if (!check) {
                    history.push(routeName.report)
                    return false
                }
            })

        /** MASTER DATA */
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data))
            .catch((e) => { return })

        TreatmentRightApi.findAll({ export: 1 })
            .then(({ data }) => setTreatmentRight([{ treatmentRightName: t('REPORT.REPORT_GROUP.ALL'), treatmentRightId: 0 }, ...data]))
            .catch((e) => { return })

        return true
    }

    useEffect(() => {
        verifyPermission()
    }, [])

    useEffect(() => {
        fetchTreatmentRightBalance()
    }, [fetchTreatmentRightBalance])
    const handleChangePage = (val: number) => setPage(val)
    const handleChangeRowsPerPage = (limit: number) => {
        setLimit(limit)
    }
    useEffect(() => {
        loadDataExport()
    }, [loadDataExport])



    const headCells = [
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.#', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.CN', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.BRANCH_CN_NUMBER', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.SN_CODE', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.PATIENT', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.TREATMENT_RIGHT', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.UNIT', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.AMOUNT', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.AMOUNT_USED', align: 'center', class: 'text-nowrap', },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_BALANCE.BALANCE', align: 'center', class: 'text-nowrap', },

    ]
    if (!snType) {
        headCells.splice(3, 1)
    }
    const renderData = (data: any, no: number) => {
        const columns = [
            { option: 'TEXT', align: 'center', label: no + 1, class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.cnNumber, class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.branchCnNumber, class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.snCode ?? '-', class: 'text-nowrap' },
            { option: 'TEXT', align: 'left', label: data.patientFullName ?? '-', class: 'text-nowrap' },
            { option: 'TEXT', align: 'left', label: data.treatmentRightName ?? '-', class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.unit || '-', class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.unit === t('REPORT.UNIT.BATH') ? numberFormat(data.amount) : data.amount, class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.unit === t('REPORT.UNIT.BATH') ? numberFormat(data.amountUsed) : data.amountUsed, class: 'text-nowrap' },
            { option: 'TEXT', align: 'center', label: data.unit === t('REPORT.UNIT.BATH') ? numberFormat(data.balance) : data.balance, class: 'text-nowrap' },
        ]
        if (!snType) {
            columns.splice(3, 1)
        }
        return <>
            <TableRowCommon
                key={no.toString()}
                id={no.toString()}
                obj={data}
                columns={columns} />
        </>
    }

    return (
        <Box sx={{ height: '100%' }}>
            <HeaderCard text={t('REPORT.REPORT_NAME.TREATMENT_RIGHT_BALANCE')} />
            <Box sx={{ px: 3, pt: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            onChange={(e) => setSearch(e.target.value)}
                            fullWidth
                            label={t('REPORT.REPORT_NAME.SEARCH_TREATMENT_RIGHT_BALANCE')}
                            value={search}
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <SelectInput
                            label={t('REPORT.FILTER.BRANCH')}
                            value={branchId}
                            onChange={e => {
                                setBranchId(Number(e.target.value));
                            }}
                            options={[
                                { value: 0, name: t(`REPORT.FILTER.ALL`) },
                                ...branches.map(b => ({
                                    value: b.branchId,
                                    name: b.branchName || b.branchNameEn || ''
                                }))]}
                            width="100%"
                        />
                    </Grid>
                    <Grid xs={12} sm={6} item md={3} xl={2}>
                        <SelectInput
                            label={t('REPORT.FILTER.TREATMENT')}
                            value={treatmentRightId}
                            onChange={(e) => setTreatmentRightId(e.target.value)}
                            options={treatmentRight.map(b => ({
                                value: b,
                                name: b.treatmentRightName || b.treatmentRightNameEN || '',
                            }))}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1} xl={1}>
                        <MainButton
                            title={t('INPUT.SEARCH')}
                            type="primary"
                            variant="contained"
                            onClick={() => {
                                setFetch(true);
                                setPage(1);
                            }}
                            style={{ width: '120px' }}
                        />
                    </Grid>
                    <Grid item xs className="d-flex justify-content-end align-items-center">
                        <UseStyled.DropdownDocument>
                            <Dropdown.Toggle id="dropdown-basic" className="ml-auto">
                                {t('PRINT_DOCUMENT')}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={onDownload}>{t('Excel')}</Dropdown.Item>
                                <Dropdown.Item onClick={() => window.print()}>{t('PDF')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </UseStyled.DropdownDocument>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, px: { xs: 1 }, pb: 4 }}>
                    <TreatmentRightBalanceList
                        page={page}
                        pageLimit={limit}
                        rowCount={rowCount}
                        data={data}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        handleChangePage={handleChangePage}
                        onRequestSort={() => { return }}
                    ></TreatmentRightBalanceList>
                </Box>
            </Box>

            <Loading show={loading} type="fullLoading" />

            <Box id="print-table-container" ref={componentRef}>
                <ExportData
                    componant={
                        <>
                            <span style={{ fontWeight: 'bold' }}>{t(`REPORT.REPORT_NAME.TREATMENT_RIGHT_BALANCE`)}</span>
                            <table>
                                <tr>
                                    {getAllFilter().map((filter: any, index: number) => (
                                        <TableSortLabel key={index} >
                                            <td className='mr-2' style={{ textAlign: 'left', fontSize: 10, fontWeight: 800 }}>{t(filter.label)} : </td>
                                            <td style={{ textAlign: 'left', fontSize: 10, fontWeight: 500 }}>{filter.value}</td>
                                        </TableSortLabel >
                                    ))}
                                </tr>
                            </table>
                            <UseStyled.Styles className="pt-3">
                                <table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            {_.map(headCells, (val: any, index: number) => {
                                                return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(dataExport, (d: any, index: number) => {
                                            return (
                                                renderData(d, index)
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </UseStyled.Styles>
                        </>
                    }
                />
            </Box>
        </Box>
    );


}

export function ExportData(props: ExportProps) {
    return <>{props.componant}</>
}